import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../components/shell/PageHeader';
import { menuIcons } from '../components/shell/menuIcons';
import { Card, CardBody } from '../components/ui/Card';
import { setupPath } from '../features/brand/paths';
import { CreateBrandWorkspaceForm } from '../features/brand-setup/create/CreateBrandWorkspaceForm';
import { CREATE_COPY } from '../features/brand-setup/wizardCopy';

/**
 * Create Brand Workspace while Brand Workspace v2 is on (spec:38-50): the name and the public website,
 * then straight to Brand Setup for the new workspace. `replace`, so Back cannot submit the form again.
 * With the flag off the route keeps today's WorkspaceFormPage.
 */
export function WorkspaceCreatePage() {
  const navigate = useNavigate();
  return (
    <div className="w-full space-y-4">
      <PageHeader
        title="Create Brand Workspace"
        icon={menuIcons.workspaceCreate}
        description={CREATE_COPY.description}
      />
      <Card>
        <CardBody>
          <CreateBrandWorkspaceForm
            submitLabel={CREATE_COPY.submit}
            onCreated={(tenant) => navigate(setupPath(tenant.slug), { replace: true })}
            onCancel={() => navigate(-1)}
          />
        </CardBody>
      </Card>
    </div>
  );
}
